import React from 'react';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { useTimeStamp } from '../../../hooks/useTimeStamp';

const WidgetSearchResult = (props) => {
  const { tveeImgUrl } = props;
  const list = props.childProps.payload.list;
  const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };

  const _goItem = (contentSerial) => {
    const { history } = props;
    history.push(`/items/${contentSerial}`);
  };
  const _goSearch = () => {
    window.open(
      `https://www.aniplustv.com/search?st=${encodeURIComponent(param)}&g=n`,
      '',
      ''
    );
  };
  return (
    <>
      <div className="widget-container">
        <div className="widget-containter-title" onClick={_goSearch}>
          <h1>[{param}] 검색 결과 더보기</h1>
        </div>
        <div>
          <ul className="widget-content-list">
            {list.map((item) => (
              <li onClick={() => _goItem(item.contentSerial)}>
                <img
                  src={tveeImgUrl + '/images/tvee-admin/content/' + item.imageL}
                />
                <div className="right">
                  <a>{item.title}</a>
                  <div className="genre-name">{item.genreName}</div>
                  <div>{item.subTitle}</div>
                  {item.regDate === undefined ||
                  item.regDate === null ||
                  item.regDate === '' ? null : (
                    <div className="date">
                      {useTimeStamp(item.regDate)}
                      {/* {moment(item.regDate).format('YYYY.MM.DD hh:mm')} */}
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="widget-time">{props.childProps.payload.writetime}</div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText === '' ||
          preText === undefined ||
          preText === null ? null : (
            <div onClick={_prev} className="prev">
              이전 단계로 이동
            </div>
          )}

          <div onClick={_goHome} className="prev">
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(WidgetSearchResult));
